import 'core-js/features/array/at';
import 'core-js/stable/parse-float';
import * as smoothscroll from 'seamless-scroll-polyfill';
import './scrollend';

if (typeof window !== 'undefined') {
  smoothscroll.polyfill();
}
